<div #formContainer class="pr-subform-container" (swiperight)="cancel()">
  <div class="pr-form-title">
    <div class="pr-form-title-primary" (click)="cancel()">
      <i class="fa fa-chevron-left" aria-hidden="true"></i>
      Retour
    </div>
    <div class="pr-form-title-secondary">
      @if (onDelete.observers.length) {
        <pr-button-confirm
          display="danger"
          icon="delete_outline"
          (onConfirm)="delete()"
          comment="Toute suppression est definitive, les données seront perdues."
          labelConfirm="Supprimer"
          labelCancel="Annuler"
        >
          Êtes-vous sûr(e) de vouloir supprimer <em>“Cet item”</em>
        </pr-button-confirm>
      }
    </div>
  </div>
  <div class="pr-form-content">
    <ng-content select="[formContent]"></ng-content>
  </div>
  <div class="pr-form-submit flex-row">
    <pr-button
      label="Annuler"
      clazz="btn-cancel neutral"
      size="lg"
      (onClick)="cancel()"
    ></pr-button>
    <pr-button
      [label]="submitbtnLabel"
      size="lg"
      display="neutral"
      (onClick)="validate()"
    ></pr-button>
  </div>
</div>
